module.exports = __webpack_public_path__ + "img/hero-band-h5.3eeea2de.svg";